(() => {
  const DAY = 86400000;
  const SYNODIC_MONTH = 29.530588853;
  const REFERENCE_NEW_MOON = Date.UTC(2000, 0, 6, 18, 14);

  const wheelFestivals = [
    ['imbolc', 2, 1, 'Imbolc', 'Late winter · light, purification, and renewal', '/blogs/pagan-festivals/imbolc-celebrating-light-purification-and-renewal', 'Brigid', 'Brigid’s Cross'],
    ['beltane', 5, 1, 'Beltane', 'Early summer · fire, vitality, and community', '/blogs/pagan-festivals/beltane-history-meaning-fire-festival-pagan-practice', '', 'Fire · hawthorn'],
    ['lughnasadh', 8, 1, 'Lughnasadh', 'First harvest · skill, gathering, and gratitude', '/blogs/pagan-festivals/lughnasadh-history-meaning-first-harvest-pagan-practice', 'Lugh', 'Grain · solar symbols'],
    ['samhain', 10, 31, 'Samhain', 'Late autumn · ancestors, threshold, and remembrance', '/blogs/pagan-festivals/what-is-samhain-and-how-is-it-celebrated', 'The Morrígan · Hecate', 'Cauldron · divination']
  ];

  const seasonalFestivalGuides = {
    ostara: ['Ostara', 'Spring equinox · balance, renewal, and new growth', '/blogs/pagan-festivals/ostara-spring-equinox-history-meaning-pagan-practice', '', 'Egg · hare · solar cross'],
    litha: ['Litha', 'Summer solstice · height of light and midsummer', '/blogs/pagan-festivals/litha-summer-solstice-history-meaning-pagan-practice', '', 'Sun wheel'],
    mabon: ['Mabon', 'Autumn equinox · harvest, balance, and transition', '/blogs/pagan-festivals/mabon-autumn-equinox-history-meaning-pagan-practice', '', 'Harvest · spiral'],
    yule: ['Yule', 'Winter solstice · midwinter and the return of light', '/blogs/pagan-festivals/yule-celebrating-the-winter-solstice-and-the-return-of-light', '', 'Sun wheel · evergreen']
  };

  const historicalRules = [
    ['janus', 1, 1, 'Kalends of January', 'Roman', 'historical', 'Historically documented', 'Roman New Year observance connected with Janus, beginnings, doors, and civic renewal.', '', 'Janus', 'Keys · doorway'],
    ['parentalia', 2, 13, 'Parentalia begins', 'Roman', 'historical', 'Historically documented', 'Opening of a Roman period of family remembrance for the dead; observances continued through February 21.', '', 'Di Manes', 'Offerings · ancestor rites'],
    ['feralia', 2, 21, 'Feralia', 'Roman', 'historical', 'Historically documented', 'The public closing day of Parentalia, associated with rites for the dead.', '', 'Di Manes', 'Offerings'],
    ['terminalia', 2, 23, 'Terminalia', 'Roman', 'deity', 'Historically documented', 'Roman festival of Terminus and boundary stones.', '', 'Terminus', 'Boundary stone'],
    ['anthesteria', 2, 26, 'Anthesteria seasonal window', 'Greek', 'historical', 'Traditional date', 'Athenian festival of Dionysus, new wine, hospitality, and the presence of the dead. Its ancient lunar date does not map to one fixed Gregorian day.', '/blogs/pagan-festivals/anthesteria-dionysus-wine-dead-athenian-festival', 'Dionysus', 'Wine · vessel'],
    ['matronalia', 3, 1, 'Matronalia', 'Roman', 'deity', 'Historically documented', 'Roman observance connected with Juno Lucina, marriage, and childbirth.', '', 'Juno Lucina', 'Torch · flower'],
    ['liberalia', 3, 17, 'Liberalia', 'Roman', 'historical', 'Historically documented', 'Roman festival associated with Liber Pater and civic coming-of-age.', '', 'Liber Pater', 'Ivy · wine'],
    ['akitu', 4, 1, 'Akitu seasonal window', 'Mesopotamian', 'historical', 'Traditional date', 'Mesopotamian New Year festival; timing and form varied by city and period.', '/blogs/pagan-festivals/akitu-babylonian-new-year-marduk-festival', 'Marduk', 'Rod and ring'],
    ['cerealia', 4, 12, 'Cerealia begins', 'Roman', 'deity', 'Historically documented', 'Opening of the Roman festival period for Ceres and the grain cycle.', '', 'Ceres', 'Grain · torch'],
    ['parilia', 4, 21, 'Parilia', 'Roman', 'historical', 'Historically documented', 'Roman pastoral festival associated with purification of flocks and the traditional birthday of Rome.', '', 'Pales', 'Fire · pastoral rites'],
    ['floralia', 4, 28, 'Floralia begins', 'Roman', 'deity', 'Historically documented', 'Roman festival of Flora associated with flowering, performance, and spring abundance.', '', 'Flora', 'Flowers'],
    ['vestalia', 6, 7, 'Vestalia begins', 'Roman', 'deity', 'Historically documented', 'Roman festival period associated with Vesta and the civic hearth.', '', 'Vesta', 'Sacred flame'],
    ['kupala', 7, 6, 'Kupala Night', 'Slavic', 'historical', 'Regional custom', 'A regional midsummer complex of fire, water, plants, and courtship customs.', '/blogs/pagan-festivals/kupala-night-fire-water-plants-slavic-midsummer', '', 'Fire · water · fern'],
    ['wepet-renpet', 7, 19, 'Wepet Renpet seasonal marker', 'Egyptian', 'historical', 'Traditional date', 'A modern calendar marker for the Egyptian opening of the year; ancient timing depended on Nile and stellar observations.', '', 'Sopdet', 'Sirius · ankh'],
    ['neptunalia', 7, 23, 'Neptunalia', 'Roman', 'deity', 'Historically documented', 'Roman summer festival of Neptune, known from ancient calendars.', '', 'Neptune', 'Trident · water'],
    ['panathenaia', 7, 28, 'Panathenaia seasonal window', 'Greek', 'deity', 'Traditional date', 'Athenian civic festival for Athena, with procession, offerings, and contests.', '/blogs/pagan-festivals/panathenaia-athena-procession-games-festival', 'Athena', 'Owl · olive · aegis'],
    ['opet', 8, 15, 'Opet Festival seasonal window', 'Egyptian', 'historical', 'Traditional date', 'Theban procession linking Karnak and Luxor; its ancient lunar timing varied.', '/blogs/pagan-festivals/opet-festival-amun-karnak-luxor-procession', 'Amun', 'Was scepter · ram'],
    ['vulcanalia', 8, 23, 'Vulcanalia', 'Roman', 'deity', 'Historically documented', 'Roman festival of Vulcan held during the dry heat of late summer.', '', 'Vulcan', 'Fire · forge'],
    ['eleusis', 9, 14, 'Eleusinian Mysteries seasonal window', 'Greek', 'historical', 'Traditional date', 'Initiatory festival complex connected with Demeter and Persephone; exact ancient dates followed the Attic calendar.', '/blogs/pagan-festivals/eleusinian-mysteries-demeter-persephone-initiation', 'Demeter · Persephone', 'Grain · torch · pomegranate'],
    ['thesmophoria', 10, 11, 'Thesmophoria seasonal window', 'Greek', 'deity', 'Traditional date', 'Women’s festival for Demeter and Kore; local dates and forms varied.', '/blogs/pagan-festivals/thesmophoria-demeter-persephone-womens-festival', 'Demeter · Persephone', 'Grain · piglet'],
    ['saturnalia', 12, 17, 'Saturnalia begins', 'Roman', 'historical', 'Historically documented', 'Roman festival of Saturn marked by feasting, gifts, and temporary social reversals.', '/blogs/pagan-festivals/saturnalia-history-dates-customs-roman-festival', 'Saturn', 'Sickle · gift'],
    ['opalia', 12, 19, 'Opalia', 'Roman', 'deity', 'Historically documented', 'Roman observance of Ops, abundance, and the stored harvest.', '', 'Ops', 'Cornucopia · grain'],
    ['historical-yule', 12, 20, 'Historical Yule season', 'Norse', 'historical', 'Traditional date', 'A seasonal entry point into historically attested Germanic midwinter traditions; dates and practices varied.', '/blogs/pagan-festivals/historical-yule-germanic-midwinter-feast', 'Odin and other regional figures', 'Evergreen · feast · sun'],
    ['larentalia', 12, 23, 'Larentalia', 'Roman', 'historical', 'Historically documented', 'Roman observance associated with Acca Larentia and ancestral tradition.', '', 'Acca Larentia', 'Ancestor offering']
  ];

  // Exact UTC instants from the US Naval Observatory Earth’s Seasons data.
  // Each row: ISO instant, event name, Northern festival, Southern festival.
  const seasonInstants = {
    2025: [['2025-03-20T09:01:00Z', 'March Equinox', 'ostara', 'mabon'], ['2025-06-21T02:42:00Z', 'June Solstice', 'litha', 'yule'], ['2025-09-22T18:19:00Z', 'September Equinox', 'mabon', 'ostara'], ['2025-12-21T15:03:00Z', 'December Solstice', 'yule', 'litha']],
    2026: [['2026-03-20T14:46:00Z', 'March Equinox', 'ostara', 'mabon'], ['2026-06-21T08:24:00Z', 'June Solstice', 'litha', 'yule'], ['2026-09-23T00:05:00Z', 'September Equinox', 'mabon', 'ostara'], ['2026-12-21T20:50:00Z', 'December Solstice', 'yule', 'litha']],
    2027: [['2027-03-20T20:25:00Z', 'March Equinox', 'ostara', 'mabon'], ['2027-06-21T14:11:00Z', 'June Solstice', 'litha', 'yule'], ['2027-09-23T06:02:00Z', 'September Equinox', 'mabon', 'ostara'], ['2027-12-22T02:42:00Z', 'December Solstice', 'yule', 'litha']],
    2028: [['2028-03-20T02:17:00Z', 'March Equinox', 'ostara', 'mabon'], ['2028-06-20T20:02:00Z', 'June Solstice', 'litha', 'yule'], ['2028-09-22T11:45:00Z', 'September Equinox', 'mabon', 'ostara'], ['2028-12-21T08:19:00Z', 'December Solstice', 'yule', 'litha']],
    2029: [['2029-03-20T08:02:00Z', 'March Equinox', 'ostara', 'mabon'], ['2029-06-21T01:48:00Z', 'June Solstice', 'litha', 'yule'], ['2029-09-22T17:38:00Z', 'September Equinox', 'mabon', 'ostara'], ['2029-12-21T14:14:00Z', 'December Solstice', 'yule', 'litha']],
    2030: [['2030-03-20T13:52:00Z', 'March Equinox', 'ostara', 'mabon'], ['2030-06-21T07:31:00Z', 'June Solstice', 'litha', 'yule'], ['2030-09-22T23:27:00Z', 'September Equinox', 'mabon', 'ostara'], ['2030-12-21T20:09:00Z', 'December Solstice', 'yule', 'litha']],
    2031: [['2031-03-20T19:41:00Z', 'March Equinox', 'ostara', 'mabon'], ['2031-06-21T13:17:00Z', 'June Solstice', 'litha', 'yule'], ['2031-09-23T05:15:00Z', 'September Equinox', 'mabon', 'ostara'], ['2031-12-22T01:55:00Z', 'December Solstice', 'yule', 'litha']],
    2032: [['2032-03-20T01:22:00Z', 'March Equinox', 'ostara', 'mabon'], ['2032-06-20T19:09:00Z', 'June Solstice', 'litha', 'yule'], ['2032-09-22T11:11:00Z', 'September Equinox', 'mabon', 'ostara'], ['2032-12-21T07:56:00Z', 'December Solstice', 'yule', 'litha']],
    2033: [['2033-03-20T07:22:00Z', 'March Equinox', 'ostara', 'mabon'], ['2033-06-21T01:01:00Z', 'June Solstice', 'litha', 'yule'], ['2033-09-22T16:51:00Z', 'September Equinox', 'mabon', 'ostara'], ['2033-12-21T13:46:00Z', 'December Solstice', 'yule', 'litha']],
    2034: [['2034-03-20T13:17:00Z', 'March Equinox', 'ostara', 'mabon'], ['2034-06-21T06:44:00Z', 'June Solstice', 'litha', 'yule'], ['2034-09-22T22:39:00Z', 'September Equinox', 'mabon', 'ostara'], ['2034-12-21T19:34:00Z', 'December Solstice', 'yule', 'litha']],
    2035: [['2035-03-20T19:02:00Z', 'March Equinox', 'ostara', 'mabon'], ['2035-06-21T12:33:00Z', 'June Solstice', 'litha', 'yule'], ['2035-09-23T04:39:00Z', 'September Equinox', 'mabon', 'ostara'], ['2035-12-22T01:31:00Z', 'December Solstice', 'yule', 'litha']]
  };

  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const pad = value => String(value).padStart(2, '0');
  const dateKey = date => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  const parseDate = value => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12) : null;
  };
  const escapeHtml = value => String(value || '').replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);

  function todayInTimezone(timezone) {
    if (!timezone || timezone === 'local') return new Date();
    try {
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
      return new Date(Number(values.year), Number(values.month) - 1, Number(values.day), 12);
    } catch (_) {
      return new Date();
    }
  }

  function moonData(date) {
    const utcNoon = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12);
    let age = ((utcNoon - REFERENCE_NEW_MOON) / DAY) % SYNODIC_MONTH;
    if (age < 0) age += SYNODIC_MONTH;
    const fraction = age / SYNODIC_MONTH;
    const illumination = Math.round((1 - Math.cos(2 * Math.PI * fraction)) * 50);
    const waxing = fraction < 0.5;
    let name = waxing ? 'Waxing crescent' : 'Waning crescent';
    let glyph = waxing ? '☽' : '☾';
    if (fraction < 0.035 || fraction > 0.965) { name = 'New Moon'; glyph = '●'; }
    else if (fraction < 0.215) { name = 'Waxing crescent'; glyph = '☽'; }
    else if (fraction < 0.285) { name = 'First Quarter'; glyph = '◐'; }
    else if (fraction < 0.465) { name = 'Waxing gibbous'; glyph = '◔'; }
    else if (fraction < 0.535) { name = 'Full Moon'; glyph = '○'; }
    else if (fraction < 0.715) { name = 'Waning gibbous'; glyph = '◕'; }
    else if (fraction < 0.785) { name = 'Last Quarter'; glyph = '◑'; }
    const phaseTargets = [
      [0, 'New Moon'],
      [SYNODIC_MONTH / 4, 'First Quarter'],
      [SYNODIC_MONTH / 2, 'Full Moon'],
      [SYNODIC_MONTH * 3 / 4, 'Last Quarter']
    ];
    const nearestPhase = phaseTargets
      .map(([target, label]) => {
        const rawDistance = Math.abs(age - target);
        return { label, distance: Math.min(rawDistance, SYNODIC_MONTH - rawDistance) };
      })
      .sort((a, b) => a.distance - b.distance)[0];
    const keyPhase = nearestPhase.distance <= 0.5 ? nearestPhase.label : '';
    return { age, fraction, illumination, waxing, name, glyph, keyPhase };
  }

  function initCalendar(root) {
    const minYear = Number(root.dataset.minYear || 2025);
    const maxYear = Number(root.dataset.maxYear || 2035);
    let timezone = localStorage.getItem('paganCalendarTimezone') || 'local';
    let today = todayInTimezone(timezone);
    const query = new URLSearchParams(location.search);
    const requested = parseDate(query.get('date'));
    let selected = requested && requested.getFullYear() >= minYear && requested.getFullYear() <= maxYear ? requested : new Date(today.getFullYear(), today.getMonth(), today.getDate(), 12);
    if (selected.getFullYear() < minYear || selected.getFullYear() > maxYear) selected = new Date(Math.min(Math.max(today.getFullYear(), minYear), maxYear), today.getMonth(), today.getDate(), 12);
    let viewYear = selected.getFullYear();
    let viewMonth = selected.getMonth();
    let hemisphere = localStorage.getItem('paganCalendarHemisphere') || 'north';
    const activeFilters = new Set(['moon', 'wheel', 'astronomy', 'historical', 'deity']);
    const activeCultures = new Set(['Egyptian', 'Greek', 'Roman', 'Norse', 'Celtic', 'Mesopotamian', 'Slavic', 'Modern Pagan']);
    const metaobjects = (() => {
      try { return JSON.parse(root.querySelector('[data-calendar-metaobjects]')?.textContent || '[]'); }
      catch (_) { return []; }
    })();

    const grid = root.querySelector('[data-calendar-grid]');
    const monthSelect = root.querySelector('[data-calendar-month]');
    const yearSelect = root.querySelector('[data-calendar-year]');
    const heading = root.querySelector('[data-calendar-heading]');
    const detailDate = root.querySelector('[data-calendar-detail-date]');
    const detailKicker = root.querySelector('[data-calendar-detail-kicker]');
    const moonCard = root.querySelector('[data-calendar-moon-card]');
    const eventList = root.querySelector('[data-calendar-event-list]');
    const phaseSummary = root.querySelector('[data-calendar-phase-summary]');
    const detail = root.querySelector('[data-calendar-detail]');
    const filtersPanel = root.querySelector('.sacred-calendar__filters');
    const filterBackdrop = root.querySelector('[data-calendar-filter-backdrop]');
    const dayTab = root.querySelector('[data-calendar-mobile-panel="day"]');
    const filtersTab = root.querySelector('[data-calendar-mobile-panel="filters"]');
    const detailScroll = root.querySelector('[data-calendar-detail-scroll]');
    let sheetState = 'peek';
    let dragStartY = 0;
    let dragStartVisibleHeight = 0;
    let dragLastY = 0;
    let dragLastTime = 0;
    let dragVelocity = 0;
    let dragPointerId = null;

    monthNames.forEach((name, index) => monthSelect.add(new Option(name, index)));
    for (let year = minYear; year <= maxYear; year += 1) yearSelect.add(new Option(year, year));
    root.querySelector('[data-calendar-timezone]').value = timezone;

    function resolvedTimezone() {
      if (timezone && timezone !== 'local') return timezone;
      return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    }

    function instantParts(iso) {
      try {
        const parts = new Intl.DateTimeFormat('en-CA', {
          timeZone: resolvedTimezone(),
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23'
        }).formatToParts(new Date(iso));
        const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
        return { key: `${values.year}-${values.month}-${values.day}`, time: `${values.hour}:${values.minute}` };
      } catch (_) {
        const fallback = new Date(iso);
        return { key: fallback.toISOString().slice(0, 10), time: `${pad(fallback.getUTCHours())}:${pad(fallback.getUTCMinutes())} UTC` };
      }
    }

    function dateEvent(year, month, day, data) {
      return { id: data.id, date: `${year}-${pad(month)}-${pad(day)}`, title: data.title, category: data.category, culture: data.culture || 'Modern Pagan', status: data.status, description: data.description, articleUrl: data.articleUrl || '', deity: data.deity || '', symbol: data.symbol || '', sourceUrl: data.sourceUrl || '', sourceLabel: data.sourceLabel || '' };
    }

    function allEventsForDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const key = dateKey(date);
      const events = [];
      wheelFestivals.forEach(item => {
        let eventMonth = item[1];
        let eventDay = item[2];
        if (hemisphere === 'south') {
          const shifted = new Date(year, eventMonth - 1 + 6, eventDay, 12);
          eventMonth = shifted.getMonth() + 1;
          eventDay = shifted.getDate();
        }
        if (eventMonth === month && eventDay === day) events.push(dateEvent(year, month, day, { id: item[0], title: item[3], category: 'wheel', culture: 'Modern Pagan', status: 'Modern Pagan observance', description: item[4], articleUrl: item[5], deity: item[6], symbol: item[7] }));
      });
      historicalRules.forEach(item => {
        if (item[1] === month && item[2] === day) events.push(dateEvent(year, month, day, { id: item[0], title: item[3], culture: item[4], category: item[5], status: item[6], description: item[7], articleUrl: item[8], deity: item[9], symbol: item[10] }));
      });
      (seasonInstants[year] || []).forEach((item, index) => {
        const instant = instantParts(item[0]);
        if (instant.key !== key) return;
        const festivalKey = hemisphere === 'south' ? item[3] : item[2];
        const guide = seasonalFestivalGuides[festivalKey];
        events.push(dateEvent(year, month, day, {
          id: `season-${year}-${index}`,
          title: item[1],
          culture: 'Astronomy',
          category: 'astronomy',
          status: 'Astronomical event',
          description: `Exact seasonal turning point: ${instant.time} in ${resolvedTimezone()}.`,
          sourceLabel: 'USNO Earth’s Seasons',
          sourceUrl: 'https://aa.usno.navy.mil/data/Earth_Seasons'
        }));
        if (guide) events.push(dateEvent(year, month, day, {
          id: `wheel-${festivalKey}-${year}`,
          title: guide[0],
          culture: 'Modern Pagan',
          category: 'wheel',
          status: 'Modern Pagan observance',
          description: guide[1],
          articleUrl: guide[2],
          deity: guide[3],
          symbol: guide[4]
        }));
      });
      const moon = moonData(date);
      if (moon.keyPhase) events.push(dateEvent(year, month, day, { id: `moon-${key}`, title: moon.keyPhase, culture: 'Astronomy', category: 'moon', status: 'Astronomical estimate', description: `${moon.illumination}% illuminated · ${moon.waxing ? 'waxing' : 'waning'} lunar cycle. Daily values are calendar estimates derived from the average synodic cycle; use the linked USNO table for the exact instant.`, sourceLabel: 'USNO Moon Phases', sourceUrl: 'https://aa.usno.navy.mil/data/MoonPhases' }));
      metaobjects.forEach((event, index) => {
        const eventHemisphere = String(event.hemisphere || 'both').trim().toLowerCase();
        if (eventHemisphere && !['both', 'global', 'all'].includes(eventHemisphere) && eventHemisphere !== hemisphere) return;
        const matchesExact = event.startDate === key;
        const start = parseDate(event.startDate);
        const end = parseDate(event.endDate);
        const matchesRange = start && end && date >= start && date <= end;
        const matchesAnnual = event.repeatRule === 'annual' && start && start.getMonth() === date.getMonth() && start.getDate() === day;
        if (matchesExact || matchesRange || matchesAnnual) events.push({
          id: event.handle || `meta-${index}`,
          date: key,
          title: event.title,
          culture: event.culture || 'Modern Pagan',
          category: event.category || 'historical',
          status: event.status || 'Editorial thematic connection',
          description: event.description || '',
          articleUrl: event.articleUrl || '',
          deity: '',
          symbol: '',
          sourceLabel: event.sourceLabel || '',
          sourceUrl: event.sourceUrl || '',
          metaLinks: [
            { label: 'Related deity', url: event.deityUrl },
            { label: 'Related symbol', url: event.symbolUrl },
            { label: 'Related product', url: event.productUrl }
          ].filter(link => link.url)
        });
      });
      return events.filter(event => activeFilters.has(event.category) && (event.category === 'moon' || event.category === 'astronomy' || activeCultures.has(event.culture)));
    }

    function updateUrl() {
      const url = new URL(location.href);
      url.searchParams.set('view', 'sacred-calendar');
      url.searchParams.set('date', dateKey(selected));
      history.replaceState({}, '', url);
    }

    function renderGrid() {
      monthSelect.value = String(viewMonth);
      yearSelect.value = String(viewYear);
      heading.textContent = `${monthNames[viewMonth]} ${viewYear}`;
      phaseSummary.textContent = `${moonData(new Date(viewYear, viewMonth, 15, 12)).name} around mid-month`;
      grid.innerHTML = '';
      const first = new Date(viewYear, viewMonth, 1, 12);
      const startOffset = (first.getDay() + 6) % 7;
      const start = new Date(viewYear, viewMonth, 1 - startOffset, 12);
      for (let index = 0; index < 42; index += 1) {
        const date = new Date(start.getFullYear(), start.getMonth(), start.getDate() + index, 12);
        const moon = moonData(date);
        const events = allEventsForDate(date);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sacred-calendar__day';
        if (date.getMonth() !== viewMonth) button.classList.add('is-outside');
        if (dateKey(date) === dateKey(today)) button.classList.add('is-today');
        if (dateKey(date) === dateKey(selected)) button.classList.add('is-selected');
        button.setAttribute('role', 'gridcell');
        button.setAttribute('aria-label', `${date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}; ${moon.name}; ${events.length} calendar events`);
        button.innerHTML = `<span class="sacred-calendar__day-number">${date.getDate()}</span><span class="sacred-calendar__moon-glyph" aria-hidden="true">${moon.glyph}</span><span class="sacred-calendar__day-markers">${events.slice(0, 4).map(event => `<i class="calendar-dot calendar-dot--${escapeHtml(event.category)}"></i>`).join('')}</span>`;
        button.addEventListener('click', () => { selected = date; viewMonth = date.getMonth(); viewYear = date.getFullYear(); root.classList.remove('is-filter-open'); updateUrl(); render(); if (matchMedia('(max-width: 740px)').matches) setSheet('half'); });
        grid.append(button);
      }
    }

    function linkMarkup(label, url) {
      return url ? `<a href="${escapeHtml(url)}">${escapeHtml(label)} <span aria-hidden="true">→</span></a>` : '';
    }

    function renderDetail() {
      const moon = moonData(selected);
      const events = allEventsForDate(selected);
      detailKicker.textContent = dateKey(selected) === dateKey(today) ? 'Today in the sacred year' : 'Selected day';
      detailDate.textContent = selected.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
      moonCard.innerHTML = `<div><span class="sacred-calendar__moon-large" aria-hidden="true">${moon.glyph}</span><div><p>Moon</p><h3>${escapeHtml(moon.name)}</h3><span>${moon.illumination}% illuminated · ${moon.waxing ? 'waxing' : 'waning'}</span></div></div><div class="sacred-calendar__illumination"><i style="width:${moon.illumination}%"></i></div>`;
      if (!events.length) eventList.innerHTML = '<div class="sacred-calendar__empty"><h3>A quiet day in the current filters</h3><p>The Moon layer is still available above. Enable more traditions or historical layers to reveal additional entries.</p></div>';
      else eventList.innerHTML = events.map(event => {
        const related = [event.deity, event.symbol].filter(Boolean);
        return `<article class="sacred-calendar__event sacred-calendar__event--${escapeHtml(event.category)}"><p class="sacred-calendar__event-kicker"><span class="calendar-dot calendar-dot--${escapeHtml(event.category)}"></span>${escapeHtml(event.culture)} · ${escapeHtml(event.status)}</p><h3>${escapeHtml(event.title)}</h3><p>${escapeHtml(event.description)}</p>${related.length ? `<div class="sacred-calendar__event-meta">${related.map(item => `<span>${escapeHtml(item)}</span>`).join('')}</div>` : ''}<div class="sacred-calendar__event-links">${linkMarkup('Read the complete guide', event.articleUrl)}${linkMarkup(event.sourceLabel || 'Source', event.sourceUrl)}${(event.metaLinks || []).map(link => linkMarkup(link.label || 'Related resource', link.url)).join('')}</div></article>`;
      }).join('');
    }

    function render() { renderGrid(); renderDetail(); syncHemisphere(); }
    function moveMonth(delta) { const next = new Date(viewYear, viewMonth + delta, 1, 12); if (next.getFullYear() < minYear || next.getFullYear() > maxYear) return; viewMonth = next.getMonth(); viewYear = next.getFullYear(); renderGrid(); }
    function goToday() { selected = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 12); viewMonth = selected.getMonth(); viewYear = selected.getFullYear(); updateUrl(); render(); setSheet('half'); }
    function syncHemisphere() { root.querySelectorAll('[data-calendar-hemisphere]').forEach(button => { const active = button.dataset.calendarHemisphere === hemisphere; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); }); }

    function setSheet(state) {
      if (!matchMedia('(max-width: 740px)').matches) return;
      detail.classList.remove('is-dragging');
      detail.style.height = '';
      detail.style.maxHeight = '';
      detail.style.transform = '';
      sheetState = state;
      detail.dataset.sheetState = state;
      root.classList.toggle('is-sheet-open', state !== 'peek');
      root.classList.toggle('is-sheet-full', state === 'full');
      if (state === 'full') detailScroll.scrollTop = 0;
      dayTab?.classList.toggle('is-active', state !== 'peek' && !root.classList.contains('is-filter-open'));
    }

    function setFilters(open) {
      root.classList.toggle('is-filter-open', open);
      filtersTab?.setAttribute('aria-expanded', String(open));
      filtersTab?.classList.toggle('is-active', open);
      filtersPanel.toggleAttribute('inert', !open && matchMedia('(max-width: 740px)').matches);
      filtersPanel.setAttribute('aria-hidden', String(!open && matchMedia('(max-width: 740px)').matches));
      detail.toggleAttribute('inert', open);
      dayTab?.classList.toggle('is-active', !open && sheetState !== 'peek');
    }

    root.querySelector('[data-calendar-prev]').addEventListener('click', () => moveMonth(-1));
    root.querySelector('[data-calendar-next]').addEventListener('click', () => moveMonth(1));
    root.querySelector('[data-calendar-today]').addEventListener('click', goToday);
    root.querySelector('[data-calendar-mobile-today]').addEventListener('click', () => { setFilters(false); goToday(); });
    monthSelect.addEventListener('change', () => { viewMonth = Number(monthSelect.value); renderGrid(); });
    yearSelect.addEventListener('change', () => { viewYear = Number(yearSelect.value); renderGrid(); });
    root.querySelector('[data-calendar-timezone]').addEventListener('change', event => {
      timezone = event.target.value;
      today = todayInTimezone(timezone);
      localStorage.setItem('paganCalendarTimezone', timezone);
      render();
    });
    root.querySelectorAll('[data-calendar-hemisphere]').forEach(button => button.addEventListener('click', () => { hemisphere = button.dataset.calendarHemisphere; localStorage.setItem('paganCalendarHemisphere', hemisphere); render(); }));
    root.querySelectorAll('[data-calendar-filter]').forEach(input => input.addEventListener('change', () => { input.checked ? activeFilters.add(input.value) : activeFilters.delete(input.value); render(); }));
    root.querySelectorAll('[data-calendar-culture]').forEach(input => input.addEventListener('change', () => { input.checked ? activeCultures.add(input.value) : activeCultures.delete(input.value); render(); }));
    root.querySelector('[data-calendar-copy-link]').addEventListener('click', async event => { updateUrl(); try { await navigator.clipboard.writeText(location.href); event.target.textContent = 'Link copied'; setTimeout(() => { event.target.textContent = 'Copy date link'; }, 1600); } catch (_) { window.prompt('Copy this date link', location.href); } });
    root.querySelector('[data-calendar-download]').addEventListener('click', () => {
      const events = allEventsForDate(selected);
      const summary = events.length ? events.map(event => event.title).join(' · ') : `Pagan Sacred Calendar · ${moonData(selected).name}`;
      const description = events.map(event => `${event.title}: ${event.description}`).join('\\n').replace(/[,;]/g, '\\$&');
      const key = dateKey(selected).replaceAll('-', '');
      const next = new Date(selected.getFullYear(), selected.getMonth(), selected.getDate() + 1, 12);
      const ics = `BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//Pagan Workshop//Sacred Calendar//EN\r\nBEGIN:VEVENT\r\nUID:${key}@pagan-workshop.com\r\nDTSTART;VALUE=DATE:${key}\r\nDTEND;VALUE=DATE:${dateKey(next).replaceAll('-', '')}\r\nSUMMARY:${summary.replace(/[,;]/g, '\\$&')}\r\nDESCRIPTION:${description}\r\nURL:${location.href}\r\nEND:VEVENT\r\nEND:VCALENDAR`;
      const anchor = document.createElement('a'); anchor.href = URL.createObjectURL(new Blob([ics], { type: 'text/calendar' })); anchor.download = `pagan-sacred-calendar-${dateKey(selected)}.ics`; anchor.click(); URL.revokeObjectURL(anchor.href);
    });
    root.querySelectorAll('[data-calendar-mobile-panel]').forEach(button => button.addEventListener('click', () => {
      if (button.dataset.calendarMobilePanel === 'filters') {
        const willOpen = !root.classList.contains('is-filter-open');
        setFilters(willOpen);
      } else {
        setFilters(false);
        setSheet(sheetState === 'peek' ? 'half' : sheetState);
      }
    }));
    filterBackdrop?.addEventListener('click', () => setFilters(false));

    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      setFilters(false);
      setSheet('peek');
    });

    const handle = root.querySelector('[data-calendar-sheet-handle]');
    const sheetViewportHeight = () => window.visualViewport?.height || window.innerHeight;
    const sheetSnapHeights = () => {
      const viewportHeight = sheetViewportHeight();
      return {
        peek: 58,
        half: Math.min(viewportHeight * .52, 520),
        full: Math.min(viewportHeight * .88, 820)
      };
    };
    const clearDragStyles = () => {
      detail.classList.remove('is-dragging');
      detail.style.height = '';
      detail.style.maxHeight = '';
      detail.style.transform = '';
    };
    const finishSheetDrag = (event, cancelled = false) => {
      if (dragPointerId === null || event.pointerId !== dragPointerId) return;

      const totalMovement = event.clientY - dragStartY;
      const tabsHeight = root.querySelector('.sacred-calendar__mobile-tabs')?.getBoundingClientRect().height || 66;
      const visibleHeight = Math.max(58, sheetViewportHeight() - tabsHeight - detail.getBoundingClientRect().top);
      const snaps = sheetSnapHeights();
      const states = ['peek', 'half', 'full'];
      let targetState = states.reduce((closest, state) => (
        Math.abs(snaps[state] - visibleHeight) < Math.abs(snaps[closest] - visibleHeight) ? state : closest
      ), 'peek');

      if (!cancelled) {
        const currentIndex = states.indexOf(sheetState);
        const decisiveDrag = Math.abs(totalMovement) > 20 || Math.abs(dragVelocity) > .18;
        if (decisiveDrag && totalMovement > 0) {
          targetState = states[Math.max(0, currentIndex - (totalMovement > 180 ? 2 : 1))];
        } else if (decisiveDrag && totalMovement < 0) {
          targetState = states[Math.min(states.length - 1, currentIndex + (totalMovement < -180 ? 2 : 1))];
        }
      } else {
        targetState = sheetState;
      }

      const releasedPointerId = dragPointerId;
      dragPointerId = null;
      if (handle.hasPointerCapture?.(releasedPointerId)) handle.releasePointerCapture(releasedPointerId);
      clearDragStyles();
      setSheet(targetState);
    };

    handle.addEventListener('pointerdown', event => {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      event.preventDefault();
      const viewportHeight = sheetViewportHeight();
      dragPointerId = event.pointerId;
      dragStartY = event.clientY;
      dragLastY = event.clientY;
      dragLastTime = performance.now();
      dragVelocity = 0;
      const tabsHeight = root.querySelector('.sacred-calendar__mobile-tabs')?.getBoundingClientRect().height || 66;
      dragStartVisibleHeight = Math.max(58, Math.min(viewportHeight * .88, viewportHeight - tabsHeight - detail.getBoundingClientRect().top));
      detail.style.height = `${dragStartVisibleHeight}px`;
      detail.style.maxHeight = `${viewportHeight * .88}px`;
      detail.style.transform = 'translateY(0)';
      detail.classList.add('is-dragging');
      handle.setPointerCapture(event.pointerId);
    });
    handle.addEventListener('pointermove', event => {
      if (dragPointerId === null || event.pointerId !== dragPointerId) return;
      event.preventDefault();
      const now = performance.now();
      const elapsed = Math.max(1, now - dragLastTime);
      dragVelocity = (event.clientY - dragLastY) / elapsed;
      dragLastY = event.clientY;
      dragLastTime = now;
      const snaps = sheetSnapHeights();
      const height = Math.max(snaps.peek, Math.min(snaps.full, dragStartVisibleHeight + dragStartY - event.clientY));
      detail.style.height = `${height}px`;
    });
    handle.addEventListener('pointerup', event => finishSheetDrag(event));
    handle.addEventListener('pointercancel', event => finishSheetDrag(event, true));
    handle.addEventListener('lostpointercapture', event => {
      if (dragPointerId !== null && event.pointerId === dragPointerId) finishSheetDrag(event, true);
    });
    setFilters(false);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { if (matchMedia('(max-width: 740px)').matches) root.classList.toggle('is-calendar-visible', entries[0].isIntersecting); }, { threshold: 0.05 });
      observer.observe(root.querySelector('.sacred-calendar__calendar-panel'));
    } else root.classList.add('is-calendar-visible');

    render();
  }

  function start() { document.querySelectorAll('[data-sacred-calendar]').forEach(initCalendar); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
